import { flexRender } from '@tanstack/react-table';

export const CellComponent = ({
  height,
  width,
  columnDef,
  context,
}: {
  height?: number;
  width: number;
  columnDef: any;
  context: any;
}) => {
  return <td style={{ height, width }}>{flexRender(columnDef, context)}</td>;
};
